<template>
  <div>
    <ScatterChartRegTicks class="chart" :chartSettings="chartSettings" :ticks="depthTicks" :responsive="responsive" :fontSize="fontSize" :height="height" :width="width" :graphData="datacollection" @onCompleteRegression="onCompleteRegression"></ScatterChartRegTicks>
    <div v-if="type == 'tile'">
      <svg class="magnify h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
  </div>
</template>

<script>
  import ChartRegressions from 'chartjs-plugin-regression'
  import ScatterChartRegTicks from '@appComponents/navbar_tabs/general_components/ScatterChartRegTicks'

  export default {
    components: {
      ScatterChartRegTicks,
    },
    data () {
      return {
        num: 50,
        ChartRegressions,
        regressionResults: null,
        fontSize: null,
        datacollection: null,
        tissueData: null,
        qWell: null,
        depthData: [],
        depthDataLabels: [],
        depthTicks: [],
        depth: null,
        mean: null,
        chartSettings: {},
      }
    },
    mounted() {
      this.setOptions();
      this.setDepthData();
      this.fillData();
      this.setFont();
    },
    methods: {
      test() {
      },
      setOptions() {
        this.chartSettings = {
          title: 'Depth Target',
          xAxisLabel: 'Depth (mm)',
          yAxisLabel: 'Intensity (a.u.)',
          xAxisScale: 'linear',
          yAxisScale: 'linear',
          fontSize: this.fontSize,
        }
      },
      setDepthData() {
        let mean = Object.values(this.graphData.Mean);
        let depth = Object.values(this.graphData.Depth);
        if(this.version == 2){
          this.depthDataLabels = [];
          this.depthTicks = [];
          for(let i = 0; i < mean.length-1; i++) {
            if(depth[0] != 0){
              this.depthData.splice(0, 0, {
                x: depth[i],
                y: mean[i],
              });
              this.depthDataLabels.push(depth[i]);
              this.depthTicks.push(depth[i]);
            }
          }
        } else {
          this.depthDataLabels = depth;
          for(let i = 0; i < mean.length-1; i++) {
              this.depthData.splice(0, 0, {
                x: depth[i],
                y: mean[i],
              });
          }
          this.depthTicks = depth.reverse();
        }
        // this.depthTicks = depth.reverse();
        // this.depthTicks = this.depthTicks.reverse();
      },
      setFont() {
        if(this.type == 'tile') {
          this.fontSize = 14;
        }
        else {
          this.fontSize = 22;
        }
      },
      fillData () {
          this.datacollection = {
              // labels: this.depth,
              datasets: [
                {
                    label: 'Depth Target',
                    data: this.depthData,
                    hoverBackgroundColor: '#2196f3',
                    backgroundColor: '#74bcf2',
                    pointRadius: 4,
                    pointHoverRadius: 8,
                    pointHitRadius: 10,
                    regressions: {
                      type: ['exponential'],
                      precision: 10,
                      line: { color: "#2196f3", width: 2 },
                      sections: [{startIndex: this.depthDataLabels[0], endIndex: this.depthDataLabels[8]}]
                    },
                }
              ]
          }
      },
      onCompleteRegression(chart) {
        if(this.type == 'tile') {
          this.regressionResults = chart.regressions.getSections(chart.graphData, 0);
          let regression = {
            type: 'depth',
            results: this.regressionResults[0].result,
          }
          this.$emit('onCompleteRegression', regression);
        }
      }
    },
    watch: {
    },
    props: {
      graphData: Object,
      height: Number,
      width: Number,
      type: String,
      responsive: Boolean,
      version: Number,
    },
  }
</script>

<style lang="scss">
  .modal-content {
        overflow: visible,
    }
</style>